import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const THERMAL =
  "https://images.unsplash.com/photo-1468787737698-f5c03f0570dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHx0aGVybWFsJTIwcG93ZXIlMjBwbGFudCUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzg0MzI3MjkyfDA&ixlib=rb-4.1.0&q=85";

export const Thermal = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const clip = useTransform(
    scrollYProgress,
    [0, 0.5],
    ["inset(18% 12% 18% 12%)", "inset(0% 0% 0% 0%)"]
  );
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [1.3, 1]);

  return (
    <section
      id="thermal"
      data-testid="thermal-section"
      ref={ref}
      className="relative bg-background py-20 md:py-28"
    >
      <motion.div
        style={{ clipPath: clip }}
        className="relative h-[80vh] md:h-screen w-full overflow-hidden"
      >
        <motion.img
          src={THERMAL}
          alt="Thermal power plant at dusk"
          style={{ y: imgY, scale }}
          className="absolute inset-0 h-[120%] w-full object-cover"
        />
        <div className="absolute inset-0 bg-background/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />

        <div className="relative z-10 h-full flex flex-col justify-center items-start px-8 md:px-16 lg:px-24">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-6">
            [ 04 — Our Specialisations ]
          </span>
          <h2 className="font-bebas uppercase leading-[0.82] text-foreground text-6xl md:text-8xl lg:text-[9vw]">
            Thermal Power
            <br />
            Specialists
          </h2>
          <p className="font-plex text-lg md:text-2xl text-foreground/80 max-w-2xl mt-8 leading-relaxed">
            Our teams are engineered for the demands of thermal power plants —
            executing complex scaffolding for boilers, ESPs and chimneys during
            critical shutdowns across India.
          </p>

          <div className="mt-10 flex flex-wrap gap-3 max-w-3xl" data-testid="specialisation-tags">
            {[
              "Thermal Power Plants",
              "Ammonia Storage Tanks",
              "Mounded Bullets",
              "Prilling Towers",
            ].map((item) => (
              <span
                key={item}
                className="font-mono text-[11px] md:text-xs uppercase tracking-widest text-foreground border border-border bg-card/60 backdrop-blur-sm px-4 py-2 hover:border-primary hover:text-primary transition-colors duration-300"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};
